import template from './employee_count_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportEmployeeCountViewModel
{
	constructor (page)
	{
		this.page = page;
		this.employee_count_department = ko.observableArray();
		this.loader = ko.observable(false);
	}

	async download_clicked()
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('department_count_report'));
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;

		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'department_count_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	show_report_help()
	{
		Grape.dialog.open('EmployeesActivePerDepartmentCountHelp', { employee_id: this.page.bindings.id });
	}
}

class ReportEmployeeCountPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportEmployeeCountViewModel(this);
	}

	async init ()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeActivePerDepartmentReport'))
			return;

		document.title = tr('Employees Active Per Department Count');
		window.current_page_title(tr('Employees Active Per Department Count'));
	}

	async updateData ()
	{
		this.viewModel.loader(true);
		let res = await Grape.fetches.getJSON('/general/get_employee_count');
		if (res != null)
			this.viewModel.employee_count_department(res);
		else
			this.viewModel.employee_count_department.removeAll();

		this.viewModel.loader(false);
	}
}

export default {
	route: '[/]general/employee_count_report',
	page_class: ReportEmployeeCountPage,
	template: template,
	template_filename: 'translation/employee_count_report'
};
